import m from "../../../../geodata/es2015/region/usa/akLow";
window.am4geodata_region_usa_akLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/akLow.js
// module id = null
// module chunks = 